import { lazy } from 'react'

const AppsLanding = lazy(() => import(/* webpackChunkName: "appsLanding" */ './apps'))

const AppsLandingRoute = ({ location: { state } }) => (
    <AppsLanding apps={state ? state.apps : []} currentApp={state ? state.app : undefined} />
)

export default AppsLandingRoute
